import React from 'react';
import axios from 'axios';
import {Switch} from "react-router";
import {Route, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import BadgeForm from './BadgeForm';
import BadgeList from "./BadgeList";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';


class Badges extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            size: {
                width: 200,
                height: 200
            }
        };
        // Create, Update, Delete handles
        this.handleAddBadge = this.handleAddBadge.bind(this);
        this.handleEditBadge = this.handleEditBadge.bind(this);
        this.handleRemoveBadge = this.handleRemoveBadge.bind(this);
    }

    handleAddBadge(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.badges, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Odznak ' + response.data.name + ' byl vytvořen.');
            this.props.history.push('/badges');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odznak se nepodařilo vytvořit!');
            this.props.history.push('/badges');
            console.log("Axios error: ", error);
        });
    }

    handleEditBadge(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.put(this.props.api.badges + "/"+ values.id, {
            ...values
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Odznak ' + response.data.name + ' byl upraven.');
            this.props.history.push('/badges');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odznak se nepodařilo upravit!');
            this.props.history.push('/badges');
            console.log('Axios error: ', error);
        });
    }

    handleRemoveBadge(badge) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.delete(this.props.api.badges + "/" + badge.id, config).then((response) => {
            this.props.addNotification('success', response.status, 'Odznak '+ badge.name + ' byl odstraněn.');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Odznak ' + badge.name + ' se nepodařilo odstranit!');
            console.log('Axios error: ', error);
        });
    }



    render() {
        return (
            /* page content */
            <div id="page-badges" className="right-col" role="main">
                <div className="page-title">
                    <div className="title-left"><h3>Odznaky</h3></div>
                </div>
                <Switch>
                    <Route exact path="/badges" component={() =>
                        <BadgeList
                            {...this.props}
                            size={this.state.size}
                            handleRemoveBadge={this.handleRemoveBadge}
                        />
                    }
                    />
                    <Route path="/badges/add" component={() =>
                        <BadgeForm
                            {...this.props}
                            title="Přidání odznaku"
                            button="Přidat"
                            size={this.state.size}
                            action={this.handleAddBadge}
                        />
                    }
                    />
                    <Route path="/badges/edit/:id" component={() =>
                        <BadgeForm
                            {...this.props}
                            title="Úprava odznaku"
                            button="Upravit"
                            size={this.state.size}
                            action={this.handleEditBadge}
                        />
                    }
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Badges));



/** WEBPACK FOOTER **
 ** ./src/containers/Badges/index.js
 **/